class StripeHelper{

  stripe = null
  stripeForm = null
  stripeCardNumber = null
  stripeCardExpiry = null
  stripeCardCvc = null
  elements = null
  style = null

  titularElement = null
  publicKey = null
  constructor(publicKey){
    this.publicKey = publicKey
    this.style = {
      base: {
        color: '#000',
        fontWeight: '400',
        lineHeight: '2.5rem',
        fontFamily: 'Poppins, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#ACACAC'
        }
      },
      invalid: {
        color: '#C13515',
        iconColor: '#C13515'
      },
    };
    this.initStripe()
  }

  initStripe(){
    if (typeof Stripe !== 'undefined') {
      this.stripe = Stripe(this.publicKey);
      this.elements = this.stripe.elements({
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap', // Fuente externa
          },
        ],
      });
    }
    else{
      console.log("Stripe is not initialized.");
    }
  }

  initFormLine(selector){
    if (this.stripe == null || document.querySelector(selector) == null) {
      setTimeout(() => {
        if(this.stripe == null){
          this.initStripe()
        }
        this.initFormLine(selector)
      }, 100)
      return
    }
    // Create an instance of the card Element
    this.stripeForm = this.elements.create('card', {
      style: this.style,
      hidePostalCode: true
    });

    // Add an instance of the card Element into the `card-element` <div>
    this.stripeForm.mount(selector);

    // Handle real-time validation errors from the card Element.
    this.stripeForm.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  initForm(selectorCard, selectorExpiry, selectorCvv, selectorTitular = null){
    if (this.stripe == null || document.querySelector(selectorCard) == null ||
      document.querySelector(selectorExpiry) == null || document.querySelector(selectorCvv) == null
    || (selectorTitular != null && document.querySelector(selectorTitular) == null)) {
      setTimeout(() => {
        if(this.stripe == null){
          this.initStripe()
        }
        this.initForm(selectorCard, selectorExpiry, selectorCvv, selectorTitular)
      }, 100)
      return
    }

    if(selectorTitular != null){
        this.titularElement = document.querySelector(selectorTitular)
    }

    let style = this.style
    this.stripeCardNumber = this.elements.create('cardNumber', {
      style,
      showIcon: true,
      placeholder: '1234 1234 1234 1234',
    });
    this.stripeCardExpiry = this.elements.create('cardExpiry', {
      style,
    });
    this.stripeCardCvc = this.elements.create('cardCvc', {
      style,
    });

    // Montar los elementos en los divs correspondientes
    this.stripeCardNumber.mount(selectorCard);
    this.stripeCardExpiry.mount(selectorExpiry);
    this.stripeCardCvc.mount(selectorCvv);

    // Manejar errores de validación
    this.stripeCardNumber.on('change', event => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  clear(){
    if(this.stripeForm != null){
      this.stripeForm.unmount()
      this.stripeForm = null
    }
    else{
      this.stripeCardNumber.unmount()
      this.stripeCardNumber = null
      this.stripeCardExpiry.unmount()
      this.stripeCardExpiry = null
      this.stripeCardCvc.unmount()
      this.stripeCardCvc = null
    }
  }

  async tokenizar() {
    if(this.stripeForm != null){
      return this.tokenizarFormLine()
    }
    return this.tokenizarForm()
  }

  async tokenizarFormLine() {
    let result = await this.stripe.createToken(this.stripeForm)
    if(result.error){
      let errorElement = document.getElementById('card-errors');
      errorElement.textContent = result.error.message;
      return null
    }
    return result.token.id
  }

  async tokenizarForm() {
    var cardholderName = this.titularElement != null ? this.titularElement.value : null;
    let result = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.stripeCardNumber, // Elemento de tarjeta
      billing_details: {
        name: cardholderName, // Nombre del titular de la tarjeta
      },
    });

    if(result.error){
      let errorElement = document.getElementById('card-errors');
      errorElement.textContent = result.error.message;
      return null
    }
    return result.paymentMethod.id
  }

  collectBankAccountForSetup(clientSecret, name, email){
    console.log(clientSecret, name, email)
    return this.stripe.collectBankAccountForSetup({
      clientSecret: clientSecret,
      params: {
        payment_method_type: 'us_bank_account',
        payment_method_data: {
          billing_details: {
            name: name,
            email: email,
          },
        },
      },
      expand: ['payment_method'],
    })
  }
  confirmSetup(clientSecret){
    return this.stripe.confirmSetup(clientSecret)
  }

}
export default StripeHelper
